import React from 'react';
import PropTypes from 'prop-types';
import HorizontalBarChart from './HorizontalBarChart';

const AtencionesPorMotivoChart = ({ data, period }) => {
  return (
    <HorizontalBarChart
      data={{
        ...data,
        datasetLabel: 'Número de Atenciones'
      }}
      period={period}
      title="Cantidad de Atenciones por Motivo"
      topLabel="Top"
      allLabel="Todos los motivos"
      tooltipSuffix=" atenciones"
      defaultTopCount={5}
      noDataIcon="bi-graph-up"
      noDataMessage="No hay datos disponibles para el período seleccionado"
      useConsistentColors={true}
      minHeight={300}
      barHeight={70}
    />
  );
};

AtencionesPorMotivoChart.propTypes = {
  data: PropTypes.shape({
    labels: PropTypes.arrayOf(PropTypes.string).isRequired,
    data: PropTypes.arrayOf(PropTypes.number).isRequired,
  }),
  period: PropTypes.string.isRequired,
};

export default AtencionesPorMotivoChart;
